/* @flow */
import produce from 'immer'

export default function reducer(
  state,
  action: any
) {
  return produce(state, draft => {
    switch (action.type) {
      case 'CHANGE_TITLE':
        draft.title = action.value
        break
      case 'CHANGE_PARAGRAPH':
        draft.paragraph = action.value
        break
      case 'CHANGE_QUOTE':
        draft.quote = action.value
        break
      case 'CHANGE_QUOTE_AUTHOR':
        draft.quoteAuthor = action.value
        break
      case 'CHANGE_QUOTE_AUTHOR_POSITION':
        draft.quoteAuthorPosition = action.value
        break
      case 'REMOVE_BACKGROUND_IMAGE':
        draft.backgroundImgUrl = ''
        draft.backgroundImgDimensions = {}
        break
      case 'CHANGE_BACKGROUND_IMAGE':
        const { url, dimensions } = action.value
        draft.backgroundImgUrl = url
        draft.backgroundImgDimensions = dimensions
        break
      case 'CHANGE_BG_OVERLAY_TRANSPARENCY':
        draft.bgOverlayTransparency = action.value
        break

      case 'CHANGE_TITLE_ALIGNMENT': {
        draft.titleAlignment = action.value
        break
      }
      case 'CHANGE_PARAGRAPH_ALIGNMENT': {
        draft.paragraphAlignment = action.value
        break
      }
      case 'CHANGE_QUOTE_ALIGNMENT': {
        draft.quoteAlignment = action.value
        break
      }
      case 'CHANGE_QUOTE_AUTHOR_ALIGNMENT': {
        draft.quoteAuthorAlignment = action.value
        break
      }
      case 'CHANGE_QUOTE_AUTHOR_POSITION_ALIGNMENT': {
        draft.quoteAuthorPositionAlignment = action.value
        break
      }
    }
  })
}
